<template>
  <div id="bitacora">
    <h6 class="success bold mb-2 ml-2">BÍTACORA DE PROYECTO</h6>
    <vx-card no-shadow>
      <template slot="footer">
        <vs-textarea
            v-model="payload.note"
            @keypress.ctrl.enter="sendNote()"
            label="Escribe tu mensaje"></vs-textarea>

        <vs-row class="flex buttons-container">
          <vs-button
              color="black"
              class="mb-2 clickable"
              icon="send"
              @click="sendNote()"
              :disabled="payload.note === ''">
          </vs-button>
          <vx-tooltip :text="showMessages ? 'Ocultar mensajes' : 'Mostrar mensajes'">
            <vs-button
                color="success"
                :icon="showMessages ? 'message' : 'speaker_notes_off'"
                @click="showMessages = !showMessages">
            </vs-button>
          </vx-tooltip>
          <vx-tooltip :text="payload.is_private ? 'Marcar como público' : 'Marcar como privado'">
            <vs-button
                color="success"
                :icon="payload.is_private ? 'lock' : 'lock_open'"
                @click="_showPrivilegesDialog()">
            </vs-button>
          </vx-tooltip>

          <vx-tooltip text="Enviar por correo electrónico">
            <vs-button
                color="success"
                icon="email"
                @click="_showDialog()">
            </vs-button>
          </vx-tooltip>
        </vs-row>
      </template>
      <div v-if="showMessages" class="message-content">
        <message-item v-for="message in messages" :message="message"/>
      </div>
    </vx-card>

    <dialog-person-selection
        title="Enviar mensaje vía correo"
        :project_id="this.project_id"
        :show.sync="showDialog"
        :value.sync="payload.emailToNotify"></dialog-person-selection>

    <dialog-person-selection
        title="Permisos de mensaje"
        :project_id="this.project_id"
        :show.sync="showPrivilegesDialog"
        :value.sync="payload.usersWithPrivileges"></dialog-person-selection>
  </div>
</template>
<script>
import MessageItem from "./MessageItem";
import DialogPersonSelection from "./DialogPersonSelection";

export default {
  name: "ProjectMessageLogger",
  components: {DialogPersonSelection, MessageItem},
  data: () => ({
    project_id: null,
    showDialog: false,
    showPrivilegesDialog: false,
    fullscreen: false,
    showMessages: true,
    messages: [],
    emailRelated: [],
    payload: {
      is_private: true,
      sendViaEmail: false,
      emailToNotify: [],
      usersWithPrivileges: [],
      note: "",
      sendIncompleteFiles: false
    }
  }),
  mounted() {
    document.onkeydown = (e) => {
      if (e.key === "Escape" && this.fullscreen) {
        e.preventDefault();
        this.fullscreen = false;
      }
    };
  },
  async beforeMount() {
    this.project_id = this.$route.params.id || null;
    await this.getNotes();
  },
  methods: {
    _showPrivilegesDialog() {
      this.payload.is_private = !this.payload.is_private;

      if (!this.payload.is_private) {
        this.showPrivilegesDialog = true;
      }
    },
    closeFullScreen() {
      this.fullscreen = false;
    },
    async getNotes(pid = this.project_id) {
      try {
        let response = await axios.get(`/api/project/${pid}/notes?order_by=created_at:desc`)
        this.messages = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    _showDialog() {
      this.showDialog = true;
    },
    async sendNote() {
      try {
        if (this.payload.note !== '') {
          this.payload.project_id = this.project_id;

          let res = await axios.post(`/api/project/${this.project_id}/notes`, this.payload);
          this.clearForm();

          swal("Ok!", "La nota se guardo correctamente!", "success");
          this.$emit("sended", res.data);
          await this.getNotes();
        }
      } catch (e) {
        console.log(e)
        //swal("Ups!", AxiosErrorException(e), "error")
      }
    },
    clearForm() {
      this.payload.note = "";
      this.payload.emailToNotify = [];
      this.is_private = true;
      this.sendViaEmail = false;
    },
    setProjectId(pid) {
      this.project_id = pid
    }
  }
}
</script>

<style scoped>
.buttons-container .vs-button {
  margin-right: 5px;
}
.md-card.fullscreen {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;
  left: 0;
  height: 100vh;
}

.md-menu-content {
  z-index: 1000;
}

.message-content {
  max-height: 280px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.message-content.fullscreen {
  max-height: 80vh;
}
</style>
<style>
.avatar-color-client {
  background-color: #ffee58;
}

.avatar-color-supplier {
  background-color: #26a69a;
}

.avatar-color-agent {
  background-color: #66bb6a;
}

.avatar-color-admin {
  background-color: #ffca28;
}
</style>
